import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { appActions } from '@app/store/app.actions';
import { AccountFacade } from '@corelabs/angular/account';
import { filter, map, tap } from 'rxjs';

export const logout = (): CanActivateFn => {
    return () => {
        const store = inject(Store);
        const accountFacade = inject(AccountFacade);

        accountFacade.logout();

        // One reset wipes every feature slice (scales as stores are added) — see clearState.
        return accountFacade.loggedOut$.pipe(
            filter((loggedOut) => loggedOut !== null),
            tap(() => store.dispatch(appActions.reset())),
            map(() => true),
        );
    };
};
